var masthead = (function ($) {
    'use strict'

    var bindEvents = false

    var _position = function ($el) {
        var position = $el.position()
        var width = $el.width()
        var navWidth = $('.masthead__nav__subnav.active').width()

        $('.masthead__nav__subnav.active').css('transform', 'translate(' + (position.left - (navWidth / 2) + (width / 2)) + 'px, 0)')
    }

    var _bind = function () {
        $('.js-menu-toggle').on('click', function () {
            $('.masthead__nav').toggleClass('active')
            $('[data-subnav]').removeClass('active').attr('style', '')
            $('body').toggleClass('menu-active')
            // Limit scroll on Mobile
            if ($(window).width() < 1250) {
                $('body').toggleClass('menu--mobile-overflow')
            } else {
                $('body').removeClass('menu--mobile-overflow')
            }
        })

        var _menuBinds = function () {

            $('.l-masthead__nav--item.menu-item-has-children').on('touchstart mouseenter click', function (event) {
                event.stopPropagation()

                $(this).focusout()

                var thisTrigger = $(this).data('trigger')
                if ($('[data-subnav="' + thisTrigger + '"]').hasClass('active')) {
                    // $('[data-subnav]').removeClass('active').attr('style', '');
                    // $('.masthead__nav [data-trigger]').removeClass('active');
                    // console.log('Event: data-trigger has .active ' + event);
                } else {
                    // $('[data-subnav]').removeClass('active').attr('style', '')

                    $('[data-subnav]').removeClass('active')
                    $('[data-subnav="' + thisTrigger + '"]').addClass('active')
                    $('.masthead__nav [data-trigger]').removeClass('active')
                    $('[data-trigger="' + thisTrigger + '"]').addClass('active')
                    // console.log('Event: data-trigger no .active ' + event);
                    _position($(this))
                }

            })

            $('.l-masthead__nav--item:not(.menu-item-has-children)').on('click', function (event) {
                window.location = $(this).find('a').first().attr('href')
                return false
            })

            if ($(window).width() < 1250) {
                $('[data-trigger]').unbind('mouseenter')
                bindEvents = true
            }

        }
        _menuBinds()

        $('header').hover(function () {
            return false
        }, function () {
            if ($('[data-subnav]').hasClass('active')) {
                // $('[data-subnav]').removeClass('active').attr('style', '')
                $('[data-subnav]').removeClass('active')
                $('.masthead__nav [data-trigger]').removeClass('active')
            }
        })

        $('[data-trigger] a').on('touchstart touch click', function (event) {
            event.preventDefault()
        })

        $('.js-subnav-toggle').on('touchstart mousedown', function (event) {
            event.preventDefault()
            $('[data-subnav]').removeClass('active')
        })

        // Event Unbinds & Resize Resets

        $(window).resize(function () {

            if ($(window).width() < 1250) {
                $('[data-trigger]').unbind('mouseenter')
                bindEvents = true
            } else if ($(window).width() > 1249) {
                // $('[data-trigger]').unbind('click');
                $('body').removeClass('menu--mobile-overflow').removeClass('menu-active')
                $('[data-subnav]').removeClass('active')
                $('.masthead__nav [data-trigger]').removeClass('active')
                if (bindEvents === true) {
                    _menuBinds()
                    bindEvents = false
                }
            }
        })
    }

    var _scroller = function () {
        $(document).scroll(function () {
            var position = $(document).scrollTop()

            if (position > 25) {
                $('.masthead').addClass('scrolling')
            } else {
                $('.masthead').removeClass('scrolling')
            }
        })
    }

    function init () {
        _bind()
        _scroller()
    }

    return {
        init: init
    }
}(jQuery))

jQuery(document).ready(function ($) {
    masthead.init()
})
